import { PayloadAction } from 'typesafe-actions';
import { AuthorizationPayrollContextActionTypes, AuthorizationPayrollState } from './types';

const AuthorizationPayrollReducer = (
  state: AuthorizationPayrollState,
  action: PayloadAction<AuthorizationPayrollContextActionTypes, any>,
): AuthorizationPayrollState => {
  switch (action.type) {
    case AuthorizationPayrollContextActionTypes.SetSelectedPayroll:
      return {
        ...state,
        selectedPayroll: action.payload,
      };
    case AuthorizationPayrollContextActionTypes.SetAuthPayrollFlowDrawerOpen:
      return {
        ...state,
        isAuthPayrollFlowDrawerOpen: action.payload,
      };
    default: {
      return state;
    }
  }
};

export { AuthorizationPayrollReducer };
